var brandInfoAll = {
  bannerInfo: {
    bannerNmae: "德世博尔",
    createTime: "2014年",
    area: "中国 常州",
    honor: ["常州高新技术企业", "EMS认证", "QMS认证"]
  },
  subsidiary: [
    {
      name: "常州",
      langname: "常州（总公司）",
      address: "江苏省常州市武进区礼嘉镇晨阳路8号",
      corporateName: "常州南鹏机械有限公司"
    }
  ],
  advantages: {
    advantages: "/static/brand/zhitong/youshi/left.png",
    advantagesTitle: "/static/brand/zhitong/youshi/top.png",
    info:
      "产品在效率、空程、温升、噪音等指标上达到了国外主流产品水平。精度保持性、传动精度和刚性等3项指标略优，疲劳寿命指标大幅优于国外主流产品。",
    type: 1
  },
  // brandAdvantage:{
  //   titleImg:"/static/brand/zhitong/tedian/left.png",
  //   oneTitle:"张跃明",
  //   twoTitle:"首席科学家",
  //   list:[
  //     "哈尔滨工业大学硕士，清华大学博士，北京工业大学博士后，北京工业大学教授。",
  //     "中国机器人减速器知名专家，中国机器人产业联盟标准组成员，智同科技 - 北京工业大学精密传动技术研究院院长。",
  //     "一直致力于齿轮啮合理论、机构学与机构动力学、数字化设计与制造等方面的教学与科研工作。",
  //     "曾荣获：国家科技重大专项4项、国家863项目1项、北京市科委重点支持项目4项、北京市教委项目2项，以及11项纵向科研项目支持。"
  //   ]
  // },
  certify: [],

  otherProductsAdvantages: {
    productsTitle: "/static/brand/zhitong/tedian/title.png",
    aboutTitleWidth: "849px",
   // textTitle:"减速机用齿轮具备了多项优点",
    textList: [
      "减速机用齿轮具备了多项优点|在伺服控制的应用上，发挥了良好的伺服刚性效应，精密定位控制；在运转平台上具备了低背隙，高效率，高输入转速，高输入扭矩，运转平顺，低噪音等特性。",
      "减速机在外观及结构设计上也力求轻薄短小|紧凑并轻量化的条件发展，它让伺服马达能在更有效率的情形下运转，并减低其回馈的负载惯量，并增加输出的扭矩。"
    ],
    textImg: "/static/brand/DESBOER/product.png",
    height: "215px",
    list: [
      {
        titleImg: "/static/brand/DESBOER/icon/1.png",
        title:"低背隙",
        infoList: [
          "超精密背隙低于1分，标准背隙低于3分，定位精准，能充分发挥伺服电机的性能。"
        ]
      },
      {
        titleImg: "/static/brand/DESBOER/icon/2.png",
        title:"低噪音",
        infoList: [
          "采用斜齿、双支撑、一体式笼式结构，噪音比直齿降低10%左右，并提高了输出的平稳性。"
        ]
      },
      {
        titleImg: "/static/brand/DESBOER/icon/3.png",
        title:"高防护",
        infoList: [
          "采用IP65防护等级，可在任恶劣境中使用"
        ]
      },
      {
        titleImg: "/static/brand/DESBOER/icon/4.png",
        title:"高负载量",
        infoList: [
          "主轴承采用锥形滚针轴承，实现高负载容量"
        ]
      },
      {
        titleImg: "/static/brand/DESBOER/icon/5.png",
        title:"高刚性、高扭矩",
        infoList: [
          "使用整体式滚珠轴承，大大提高了刚性和扭矩"
        ]
      },
      {
        titleImg: "/static/brand/DESBOER/icon/6.png",
        title:"输法兰、连接器方式",
        infoList: [
          "简化了与设备的连接，并可以安装到世界上任何一台马达上。"
        ]
      },
      {
        titleImg: "/static/brand/DESBOER/icon/7.png",
        title:"无润滑脂泄露",
        infoList: [
          "使用高粘度、不易分离的润滑脂，有效防止润滑脂泄漏。"
        ]
      },
      {
        titleImg: "/static/brand/DESBOER/icon/8.png",
        title:"长寿命、维护方便",
        infoList: [
          "长寿命、维护方便：在产品20000小时的使用寿命内无需更换润滑脂，使用更省心"
        ]
      }
    ]
  },
  pindustry: {
    industryTitleImg: "/static/brand/zhitong/hangye/industryTitleImg.png",
    list: [
      {
        bjimg: "/static/brand/DESBOER/industry/1.png",
        title: "食品轻工"
      },
      {
        bjimg: "/static/brand/DESBOER/industry/2.png",
        title: "电力机械"
      },
      {
        bjimg: "/static/brand/DESBOER/industry/3.png",
        title: "建筑机械"
      },
      {
        bjimg: "/static/brand/DESBOER/industry/4.png",
        title: "冶金机械"
      },
      {
        bjimg: "/static/brand/DESBOER/industry/5.png",
        title: "电子电器"
      },
      {
        bjimg: "/static/brand/DESBOER/industry/6.png",
        title: "化工机械"
      },
      {
        bjimg: "/static/brand/DESBOER/industry/7.png",
        title: "矿山机械"
      },
      {
        bjimg: "/static/brand/DESBOER/industry/8.png",
        title: "输送机械"
      }
    ]
  },
  bigimg: "/static/brand/zhitong/bigimg/big.png",

  aboutus: {
    info:
      "中国常州组建DESBOER（中国）-常州南鹏机械有限公司主要从事DESBOER高精密行星减速器的研究开发、生产及销售，为客户提供一站式完美协调的产品服务与体验。DESBOER一直非常注重产品的适用性和可靠性，实施严格的质量把控。为了满足当今越来越苛刻的生产使用需求，公司以不断创新，研发之精神，创造高品质、高效率、特高性价比、适用于不同工况的精密行星式减速器。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;现如今，DESBOER研发的新一代低背隙行星减速器系列产品，具有高精度、扭转刚度高、可靠性高、低噪音、长寿命、免维护等特点，被广泛应用于机器人技术、机械手臂、机床和制造系统、食品和包装设备、印刷机械和自动化生产线等各个领域。为了满足越来越大的亚洲市场的需求，更好地服务于我们的客户，公司的管理开始实行本土化的经营原则。在工业自动化方案研发理念、系统架构及服务理念方面DESBOER赢得了业界的广泛认同，非常感谢来自亚洲各行各业的客户支持与信赖。",
    poster: "/static/brand/DESBOER/video.png",
    aboutTitle: "/static/brand/DESBOER/top.png",
    aboutTitleWidth: "570px"
  },

  metaInfo: {
    title: "德世博尔_Movibot品牌_行星减速机",
    keywords: "行星减速机_高精度行星减速机_工业机器人_德世博尔_DESBOER",
    description:
      "德世博尔DESBOER是高精密行星减速器服务商，MOVIBOT为您提供该品牌及产品介绍，丰富的产品选型，让您更快速准确的找到所需商品。"
  }
};
export default {
  brandInfoAll
};



// WEBPACK FOOTER //
// ./src/data/brand/9.js